<div class="popup-overlay" (click)="closeEvent()"></div>

<div class="cal-event-popup">
  <svg width="15" height="25" viewBox="0 0 15 25" class="popup-arrow">
    <path d="M14.0003 11.382C14.6669 11.9783 14.6669 13.0217 14.0003 13.618L3.02616 23.4349C2.05986 24.2993 0.526087 23.6134 0.526087 22.3169L0.526087 2.68311C0.526088 1.3866 2.05986 0.700743 3.02616 1.56515L14.0003 11.382Z" fill="currentColor" stroke="currentColor"/>
  </svg>

  <div class="event-content">
    <div class="close-btn-box">
      <button class="no-style close-btn" (click)="closeEvent()">
        <mat-icon [svgIcon]="'close'" class="square-icon close-icon"></mat-icon>
      </button>
    </div>

    <h4 *ngIf="event.locationLink; else linkTitleBlock" class="ellipsis-text event-title">
      <a [attr.href]="event.locationLink" target="_blank">{{ event.name }}</a>
    </h4>
    <ng-template #linkTitleBlock>
      <h4 class="ellipsis-text event-title">{{ event.name }}</h4>
    </ng-template>

    <div class="event-date">
      <mat-icon [svgIcon]="'clock'" class="square-icon event-icon"></mat-icon>

      {{ event.date | date: "dd/MM/yyyy" }}<br/>
      {{ event.date?.replace('Z', '')| date: "HH:mm" }}
    </div>

    <div class="separator"></div>

    <div>
      <span *ngIf="event.mainLecturerName">{{event.mainLecturerName}}<br/></span>
      <span *ngIf="event.type">{{event.type}}</span>
      <span *ngIf="event.description"> | {{event.description}}</span>
    </div>

    <div *ngIf="event.location" class="event-location">
      <mat-icon [svgIcon]="'location'" class="square-icon event-icon"></mat-icon>
      <span *ngIf="event.gpsX; else locationMapText">
        <a class="event-location-text" (click)="locatinPicker.openMapsModal()">{{event.location}}</a>
      </span>
      <ng-template #locationMapText>
        <div class="event-location-text">
          {{event.location}}
        </div>
      </ng-template>
    </div>

    <div class="separator"></div>

    <div class="event-actions">
      <a *ngIf="nooficationCount > 0" class="notification-link" (click)="openNotificationClick($event)">
        <mat-icon [svgIcon]="'bell-point'" class="notification-icon"></mat-icon>
        <span class="notification-text">{{nooficationCount}} {{nooficationText}}</span>
      </a>

      <app-share-button [btnClass]="'btn-sm'" style="min-width: inherit;" (addToCalendarClick)="addToCalendarClick($event)"/>
    </div>

  </div>
</div>

<app-location-select-picker #locatinPicker [gpsX]="event.gpsX" [gpsY]="event.gpsY" />